<template>
    <div class="az-actions-form">
        <v-btn @click="tratarEventoVoltar" color="grey" outlined text>
            <v-icon class="mr-1" size="15">fas fa-arrow-left</v-icon>
            VOLTAR
        </v-btn>
        <v-spacer/>
        <v-btn
            @click="tratarEventoAtivar"
            color="primary"
            depressed
            :disabled="!verificaPermissaoEdicao"
            v-if="isCamposObrigatoriosPreennchidos">
            <v-icon class="mr-1" size="15">fas fa-check</v-icon>
            Ativar
        </v-btn>
        <v-tooltip
            max-width="250"
            nudge-left="-10"
            top
            v-else>
            <template v-slot:activator="{ on }">
                <div v-on="on" :class="{'btn-disabled': !isCamposObrigatoriosPreennchidos}">
                    <v-btn
                        :disabled="!isCamposObrigatoriosPreennchidos || !verificaPermissaoEdicao"
                        color="primary"
                        depressed>
                        <v-icon class="mr-1" size="15">fas fa-check</v-icon>
                        Ativar
                    </v-btn>
                </div>
            </template>
            {{textoTooltip}}
        </v-tooltip>
    </div>
</template>

<script>
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {createNamespacedHelpers} from 'vuex'

    const { mapGetters } = createNamespacedHelpers('CamposPersonalizados')

    export default {
        props: {
            patrimonio: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            tratarEventoAtivar() {
                this.mostrarConfirmacao({
                    titulo: 'Atenção!',
                    subTitulo: 'O memorando será disponibilizado na relação de documentos para assinatura.',
                    textoBotaoConfirm: 'Confirmar',
                    icon: 'warning'
                }, async (result) => {
                    if (result.isConfirmed){
                        this.$emit('ativar')
                    }
                })
            },
            tratarEventoVoltar() {
                this.$emit('voltar')
            },
            permissaoRetroativaExpirada() {
                let dataLimite = new Date(this.$store.state.parametros.dataLimiteRetroativo)
                return new Date().getTime() > dataLimite.getTime()
            }
        },
        computed: {
            ...mapGetters(['getObjetoValidado']),
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
            verificaPermissaoRetroativa() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Retroativo'])
            },
            isPatrimonioProntoParaUso() {
                return this.patrimonio.estado === 'PRONTO_PARA_USO'
            },
            isCamposObrigatoriosPreennchidos() {
                return !!(this.getObjetoValidado(this.patrimonio, 'DADOS_DE_ENTRADA_EDICAO', this.verificaPermissaoRetroativa, this.permissaoRetroativaExpirada()) && this.isPatrimonioProntoParaUso)
            },
            textoTooltip() {
                if(!this.isPatrimonioProntoParaUso) return 'Patrimônios em desenvolvimento não podem ser ativados.'
                return 'É necessário preencher todos os campos obrigatórios para ativar.'
            }
        }
    }
</script>
